<!-- eslint-disable -->
<template lang="pug">
    .form(v-if="isAccessToForm")
        .form__container
            .form__title
                | {{ pageTitle }}
            form.form__body(
                action="javascript://"
                @submit="submitForm"
                v-if="!isLoading"
            )
                .form__field
                    .form__label
                        | {{ $i18n.t('school.school_form_name') }}
                    .form__field-body
                        cs-input.form__input(
                            :error="errors.has('name')"
                            type="text"
                            v-model="stock.name"
                            name="name"
                            v-validate="'required'"
                            :data-vv-as="$i18n.t('billing.billing_stocks_name')"
                        )
                        help-text(v-if="errors.has('name')" error)
                            | {{ errors.first('name')}}
                .form__field.fields__element_date
                    .form__label
                        | {{ $i18n.t('fields.fields_period') }}
                    .form__field-body
                        .fields__element--period
                            cs-datepicker.form__input.datepicker-input-container--no-margin(
                                :language='user.locale',
                                :value='stock.start',
                                :format="customFormatter",
                                @input="stock.start = dateToMoment($event, 'YYYY-MM-DD')",
                                v-validate='`required|date_format:YYYY-MM-DD`',
                                :data-vv-as="$i18n.t('billing.billing_stocks_startDate').toLowerCase()",
                                name='startDate'
                                )
                            div.fields__divider —
                            cs-datepicker.form__input.datepicker-input-container--no-margin(
                                :language='user.locale',
                                :value='stock.end',
                                :format="customFormatter",
                                @input="stock.end = dateToMoment($event, 'YYYY-MM-DD')",
                                v-validate='`required|date_format:YYYY-MM-DD|after:${stock.start}`',
                                :data-vv-as="$i18n.t('billing.billing_stocks_endDate').toLowerCase()",
                                name='endDate'
                            )
                        help-text(slot='help-text', v-if="errors.has('startDate')", error)
                            | {{ errors.first('startDate') }}
                        help-text(slot='help-text', v-if="errors.has('endDate')", error)
                            | {{ errors.first('endDate') }}
                divider
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.billing_stocks_description') }}
                    .form__field-body
                        textarea.form__textarea(
                            :class="{'is-danger': errors.has('description')}"
                            v-model="stock.description"
                            name="description"
                            v-validate="'max:30'"
                            :data-vv-as="$i18n.t('billing.billing_stocks_description').toLowerCase()"
                        )
                        help-text(slot='help-text', v-show="errors.has('description')", error)
                            | {{ errors.first('description') }}
                .form__field
                    .form__label
                    .form__field-body
                        help-text(
                            slot='help-text',
                            v-if="stock && stock.start && stock.end"
                            v-text=" $i18n.t('billing.billing_stocks_dateHelper', {\
                               from: stock.start + ' 00:00:00',\
                               to: stock.end + ' 00:00:00'\
                            })"
                        )
                divider
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.billing_stocks_forStudentPayedSchools') }}
                    .form__field-body
                        cs-checkbox(
                            v-model='stock.forStudentPayedSchools'
                        )
                divider
                .form__field
                    .form__label.form__label--bold
                        | {{ $i18n.t('billing.billing_edit_minimalPayment') }}
                    .form__field-body
                template(v-for='course in courseTypes')
                    .form__field
                        .form__label
                            | {{ $i18n.t('common.common_course_' + course) }}
                        .form__field-body
                            cs-input.input-number.input-number--small(
                                :error="errors.has(camelCase(course + 'MinPayment'))",
                                type='number',
                                :value='stock[camelCase(course + \'MinPayment\')]',
                                :name='camelCase(course + \'MinPayment\')',
                                onkeydown="if (`${this.value}`.length >= 9 && event.keyCode !== 8) return false;"
                                v-validate="'required|max:9|min_value:0'",
                                @input.native="handlePriceInput(camelCase(course + 'MinPayment'), $event.target.value)"
                                :data-vv-as="$i18n.t('billing.billing_edit_minimalPayment').toLowerCase()"
                                step="0.01"
                            )
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.billing_settings_schools') }}
                    .form__field-body
                        cs-multiselect(
                            :options="schools",
                            v-model="stock.schools",
                            :placeholder="schoolsPlaceholder",
                            label="name",
                            trackBy="id",
                            :loading="loadingSchools",
                            @open="getSchools",
                            :hideSelected="true",
                            :showNoResults="false",
                            :closeOnSelect="false",
                            :searchable="true",
                            :disabled="!!notIncludedSchools.length",
                        )
                .form__field
                    .form__label
                    .form__field-body
                        help-text(slot='help-text', v-text="$i18n.t('billing.billing_stocks_schoolsHelper')")
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.billing_settings_schoolsNotIncluding') }}
                    .form__field-body
                        cs-multiselect(
                            :options="schools",
                            v-model="notIncludedSchools",
                            :placeholder="notIncludedSchoolsPlaceholder",
                            label="name",
                            trackBy="id",
                            :loading="loadingSchools",
                            @open="getSchools",
                            :hideSelected="true",
                            :showNoResults="false",
                            :closeOnSelect="false",
                            :searchable="true",
                            :disabled="!!stock.schools.length",
                        )
                template(v-if="!stock.forStudentPayedSchools")
                    divider
                    .form__field
                        .table-responsive-container
                            .table-responsive
                                table.forks-table(@wheel='handleScroll($event)')
                                    thead.forks-table__thead
                                        tr.forks-table__row
                                            th.forks-table__column.forks-table__column--separate.forks-table__column--bold(colspan="2")
                                                | {{ $i18n.t('billing.billing_settings_forks') }}
                                            th.forks-table__column(v-for='course in courseTypes')
                                                | {{ $i18n.t('common.common_course_' + course) }}
                                            th.forks-table__column.forks-table__column--last
                                    tbody.forks-table__thead
                                        tr.forks-table__row(v-for='(fork, index) in stock.forks')
                                            td.forks-table__column.forks-table__column--x-small
                                                span.forks-table__fork-preview
                                                    | {{ $i18n.t('billing.billing_stocks_from').toLowerCase() }}
                                                    |
                                                    span.forks-table__fork-value {{ fork.left }}
                                                    |
                                                    | {{ $i18n.t('billing.billing_stocks_to').toLowerCase() }}
                                            td.forks-table__column.forks-table__column--small.forks-table__column--separate
                                                cs-input.input-number(
                                                    :value='fork.right',
                                                    type="number"
                                                    @input.stop.native='changeRelativeForks($event, index)',
                                                    :disabled='fork.right === null && fork === stock.forks[stock.forks.length - 1]'
                                                    :placeholder="$i18n.t('billing.billing_stocks_infinity').toLowerCase()"
                                                    :data-vv-as="$i18n.t('billing.billing_stocks_to').toLowerCase()"
                                                    :name="'rightFork' + index"
                                                    v-validate="`required|min_value:${fork.left + 1}|numeric`",
                                                    :error="errors.has('rightFork' + index)"
                                                )
                                            td.forks-table__column(v-for="(courseType, courseIndex) in courseTypes")
                                                cs-input.input-number(
                                                    type='number'
                                                    @input.stop.native="handlePriceInput('forkPrice', $event.target.value, index, courseType + 'Price')"
                                                    :value="fork[courseType + 'Price']"
                                                    :placeholder="$i18n.t('billing.billing_stocks_price')"
                                                    onkeydown="if (`${this.value}`.length >= 9 && event.keyCode !== 8) return false;"
                                                    v-validate="'required|max:9|min_value:0|numeric'"
                                                    :name="'coursePriceOfFork' + index + 'Course' + courseIndex"
                                                    :data-vv-as="$i18n.t('billing.billing_stocks_price').toLowerCase()"
                                                    :error="errors.has('coursePriceOfFork' + index + 'Course' + courseIndex)"
                                                    step="0.01"
                                                )
                                            td.forks-table__column.forks-table__column--last
                                                cs-button(
                                                    color="green"
                                                    pattern="primary-outline"
                                                    @click.prevent='removeRange(index)',
                                                    :disabled='stock.forks.length <= 2 || index === 0 || index === stock.forks.length - 1'
                                                    narrow
                                                )
                                                    svg-icon(name='close', middle='')
                .form__buttons
                    cs-button(color="blue", pattern="primary-outline", @click.prevent='addRange', narrow)
                        svg-icon(name="plus" size="large" slot="icon")
                        | {{ $i18n.t('billing.billing_stocks_addFork') }}
                divider
                .form__buttons
                    cs-button.form__button(
                        color="blue"
                        type="submit"
                        :loading="isLoading"
                        @click="submitForm"
                    )
                        | {{ $i18n.t('homework.homework_create_save') }}
                    cs-button.form__button(
                        color="blue"
                        pattern="primary-outline"
                        @click.prevent="$router.back()"
                    )
                        | {{ $i18n.t('common.common_button_cancel') }}
            cs-loader(v-else)
    div(v-else)
        .content-box.list
            .box-body
                .column.is-12-mobile.list-item.field-column
                    | {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    import { mapState } from 'vuex';
    import moment from 'moment';
    import SchoolApi from '../../../api/school';
    import { cloneDeep, camelCase } from 'lodash';
    import StocksApi from '../../../api/billing/stocks';

    export default {
        props: {
            copy: {
                type: Object,
                default: null,
            },
            type: {
                type: String,
                default: 'stocks',
            },
            page: {
                type: [String, Number],
            },
            id: {
                type: [Number, String],
            },
        },
        mounted() {
            this.fetchData();
        },
        data() {
            return {
                stock: {
                    name: '',
                    schools: [],
                    start: null,
                    end: null,
                    forks: [
                        {
                            left: 0,
                            right: 5,
                            mentalArithmeticPrice: 0,
                            fastReadingPrice: 0,
                            onlineSchoolPrice: 0,
                            mathMagicPrice: 0,
                            memoryDevelopmentPrice: 0,
                            multiplicationPrice: 0,
                            readingEnPrice: 0,
                            russianLanguagePrice: 0,
                        },
                        {
                            left: 6,
                            right: null,
                            mentalArithmeticPrice: 0,
                            fastReadingPrice: 0,
                            onlineSchoolPrice: 0,
                            mathMagicPrice: 0,
                            memoryDevelopmentPrice: 0,
                            multiplicationPrice: 0,
                            readingEnPrice: 0,
                            russianLanguagePrice: 0,
                        },
                    ],
                    mentalArithmeticMinPayment: 0,
                    fastReadingMinPayment: 0,
                    onlineSchoolMinPayment: 0,
                    mathMagicMinPayment: 0,
                    memoryDevelopmentMinPayment: 0,
                    multiplicationMinPayment: 0,
                    readingEnMinPayment: 0,
                    russianLanguageMinPayment: 0,
                    forStudentPayedSchools: false,
                },
                schools: [],
                notIncludedSchools: [],
                loadingSchools: false,
                isLoading: false,
                courseTypes: [
                    'mentalArithmetic',
                    'fastReading',
                    'onlineSchool',
                    'mathMagic',
                    'memoryDevelopment',
                    'multiplication',
                    'readingEn',
                    'russianLanguage',
                ],
            };
        },
        methods: {
            fetchData() {
                if (this.copy || this.id) {
                    let id = (this.copy && this.copy.id) || this.id;
                    StocksApi.show(id)
                        .then(stock => {
                            this.stock = stock;
                            this.stock.end = this.dateToMoment(this.stock.end, 'YYYY-MM-DD');
                            this.stock.start = this.dateToMoment(this.stock.start, 'YYYY-MM-DD');
                        })
                        .catch(err => this.$toasted(err));
                }
            },
            showErrorMessage(err) {
                this.isLoading = false;
                if (err.data) {
                    this.$toasted.error(err.message);
                }
            },
            getSchools() {
                if (this.schools.length) {
                    return;
                }
                this.loadingSchools = true;
                SchoolApi.list({ all: true, studentPayed: Number(this.stock.forStudentPayedSchools), isBilling: true })
                    .then(data => {
                        let schools = data.schools;
                        this.schools = schools ? schools : [];
                        this.loadingSchools = false;
                    })
                    .catch(() => {
                        this.loadingSchools = false;
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    });
            },
            submitForm() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        if (this.notIncludedSchools.length === this.stock.schools.length) {
                            this.$toasted.error(this.$i18n.t('billing.billing_stocks_schoolsError'));
                            return;
                        }
                        this.isLoading = true;
                        let stockCopy = cloneDeep(this.stock);
                        if (this.copy && !this.id) {
                            delete stockCopy.id;
                            delete stockCopy.isActive;
                            delete stockCopy.updatedAt;
                            delete stockCopy.createdAt;
                        }
                        if (this.notIncludedSchools.length) {
                            const notIncludedSchoolsIds = this.notIncludedSchools.map(school => school.id);
                            stockCopy.schools = this.schools.filter(school => {
                                return !notIncludedSchoolsIds.includes(school.id);
                            });
                        }
                        let params = +this.id ? { id: +this.id, stock: stockCopy } : stockCopy;
                        StocksApi[this.id ? 'update' : 'create'](params)
                            .then(() => {
                                this.$router.push({ name: 'stocks:list' });
                            })
                            .catch(err => this.showErrorMessage(err));
                    }
                });
            },
            dateToMoment(date, format) {
                return moment(date).format(format);
            },
            handlePriceInput(field, number, forkIndex = undefined, coursePriceType = undefined) {
                if (!forkIndex && forkIndex !== 0) {
                    this.stock[field] = Math.round(number * 100) / 100;
                } else {
                    this.stock.forks[forkIndex][coursePriceType] = Math.round(number * 100) / 100;
                }
            },
            handleStudentPayedFlagClicked() {
                this.stock.schools = [];
                this.schools = [];
                this.stock.forks = [];
                this.stock.forks.push({
                    left: 0,
                    right: 5,
                    mentalArithmeticPrice: 0,
                    fastReadingPrice: 0,
                    onlineSchoolPrice: 0,
                    mathMagicPrice: 0,
                    memoryDevelopmentPrice: 0,
                    multiplicationPrice: 0,
                    readingEnPrice: 0,
                    russianLanguagePrice: 0,
                });
                this.stock.forks.push({
                    left: 6,
                    right: null,
                    mentalArithmeticPrice: 0,
                    fastReadingPrice: 0,
                    onlineSchoolPrice: 0,
                    mathMagicPrice: 0,
                    memoryDevelopmentPrice: 0,
                    multiplicationPrice: 0,
                    readingEnPrice: 0,
                    russianLanguagePrice: 0,
                });
            },
            changeRelativeForks(event, index) {
                this.stock.forks[index].right = event.target.value;
                this.stock.forks[index + 1].left = Number(event.target.value) + 1;
            },
            addRange() {
                this.stock.forks.push({
                    left: null,
                    right: null,
                    mentalArithmeticPrice: 0,
                    fastReadingPrice: 0,
                    onlineSchoolPrice: 0,
                    mathMagicPrice: 0,
                    memoryDevelopmentPrice: 0,
                    multiplicationPrice: 0,
                    readingEnPrice: 0,
                    russianLanguagePrice: 0,
                });
            },
            removeRange(index) {
                if (this.stock.forks.length > 2) {
                    this.stock.forks.splice(index, 1);
                    this.stock.forks[index - 1].right = this.stock.forks[index].left - 1;
                }
                if (this.errors && this.errors.items && this.errors.items.length) {
                    this.errors.items.forEach(item => {
                        if (item.field.includes('rightFork')) {
                            item.field = '';
                        }
                    });
                }
            },
            handleScroll(event) {
                event = window.event || event;
                let delta = Math.max(-1, Math.min(1, event.wheelDelta || -event.detail));
                document.querySelector('.forks-table').scrollLeft -= delta * 65;
                event.preventDefault();
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            camelCase,
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            schoolsPlaceholder() {
                if (this.stock.schools.length) {
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                } else if (this.notIncludedSchools.length) {
                    return this.$i18n.t('fields.fields_chooseSchoolPlaceholder');
                }
                return this.$i18n.t('olympiads.olympiads_olympiadForm_allSchools');
            },
            notIncludedSchoolsPlaceholder() {
                if (this.notIncludedSchools.length) {
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                }
                return this.$i18n.t('fields.fields_chooseSchoolPlaceholder');
            },
            pageTitle() {
                return !this.id
                    ? this.$i18n.t('billing.billing_stocks_createTitle')
                    : this.$i18n.t('billing.billing_stocks_updateTitle');
            },
            isAccessToForm() {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .input-number {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        -moz-appearance: textfield;
    }

    .input-number--small {
        max-width: 160px;
    }

    .forks-table {
        display: block;
        overflow-x: auto;
        //align-self: center;
        border-collapse: separate;
        border-spacing: 0;
        width: auto;
        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        &::-webkit-scrollbar,
        &::-webkit-scrollbar {
            background-color: #f5f5f5;
            height: 2px;
        }
        &::-webkit-scrollbar-thumb,
        &::-webkit-scrollbar-thumb {
            height: 2px;
            background: $color-grey-600;
        }
    }

    .forks-table__row {
        height: 45px;
    }

    .forks-table__thead {
        font-size: 14px;
        line-height: 20px;
    }

    .forks-table__tbody {
        font-size: 16px;
        line-height: 19px;
    }

    .forks-table__column {
        font-weight: normal;
        min-width: 129px;
        text-align: right;
        padding: 4px;
        vertical-align: middle;
    }

    .forks-table__column--small {
        min-width: 100px;
        max-width: 120px;
    }

    .forks-table__column--x-small {
        min-width: 80px;
    }

    .forks-table__column--separate {
        text-align: right;
        padding-right: 16px;
    }

    .forks-table__column--last {
        min-width: 0;
        width: 50px;
        text-align: right;
    }

    .forks-table__column--last .cs-button--narrow {
        height: 45px;
        padding: 12px 15px;
    }

    .forks-table__column--last .cs-button--disabled {
        border: 1px solid #bdbdbd;
        background-color: transparent;
    }

    .forks-table__column--bold {
        font-weight: 500;
    }

    .forks-table__fork-preview {
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
    }

    .forks-table__fork-value {
        font-weight: 500;
    }

    .table-responsive-container {
        display: grid;
    }

    .table-responsive {
        overflow-x: auto;
    }
</style>

<style lang="scss" scoped>
    @import '@/assets/sass/forms/form.scss';

    .form__textarea {
        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: #fff;
        box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 180px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .fields__element_date {
        @include media($xlg) {
            display: flex;
            align-items: baseline;
        }
    }

    .fields__element--period {
        display: flex;
        flex-direction: row;
        align-items: center;
        @include stack-space($space-base);
        @include media($xlg) {
            padding: 0;
        }
    }

    .fields__divider {
        text-align: center;
        margin: 0 $space-x-small;
    }
</style>
